"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const react_1 = __importStar(require("react"));
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const styled_1 = __importDefault(require("../utils/styled"));
const Icon_1 = require("../Icon");
const TopbarSelectContainer = styled_1.default("div") `
  line-height: 1;
  height: ${props => props.theme.topbarHeight - (props.isActive ? 1 : 0)}px;
  display: flex;
  align-items: center;
  padding: 0px ${props => props.theme.space.medium}px;
  box-shadow: ${props => (props.isActive ? props.theme.shadows.contextMenu : "none")};
  border-bottom: 1px solid transparent;
  cursor: pointer;
  background-color: ${props => (props.isActive ? props.theme.color.white : "transparent")};
  color: ${props => props.theme.color.text.dark};
  & svg {
    /** Icons are purely presentational and click events are handled upstream */
    pointer-events: none;
  }
  :focus {
    ${({ theme }) => utils_1.inputFocus({ theme })};
  }
`;
const TopbarSelectValue = styled_1.default("div") `
  padding: 0px ${props => props.theme.space.base}px;
  font-size: ${props => props.theme.font.size.small}px;
  display: flex;
  align-items: center;
`;
const TopbarSelectValueSpan = styled_1.default("span") `
  margin-right: ${props => props.theme.space.element}px;
`;
const TopbarSelectLabel = styled_1.default("p") `
  margin: 0px ${props => props.theme.space.element}px 0px 0px;
  font-size: ${props => props.theme.font.size.small}px;
  font-weight: ${props => props.theme.font.weight.medium};
`;
const TopbarSelect = (_a) => {
    var { label, selected, items, onChange } = _a, props = __rest(_a, ["label", "selected", "items", "onChange"]);
    const [containerWidth, setContainerWidth] = react_1.useState(0);
    const Icon = react_1.useMemo(() => {
        const item = items.find(item => (typeof item === "string" ? false : item.label === selected));
        return typeof item === "object" && item.icon;
    }, [items, selected]);
    const $container = react_1.useRef(null);
    react_1.useLayoutEffect(() => {
        if ($container.current) {
            setContainerWidth($container.current.clientWidth);
        }
    });
    return (react_1.default.createElement(ContextMenu_1.default, { anchored: true, condensed: true, items: items, width: containerWidth, onClick: newItem => {
            if (onChange) {
                onChange(newItem);
            }
        } }, isActive => (react_1.default.createElement(TopbarSelectContainer, Object.assign({}, props, { isActive: isActive, ref: $container }),
        react_1.default.createElement(TopbarSelectLabel, null, label),
        react_1.default.createElement(TopbarSelectValue, null,
            Icon && react_1.default.createElement(Icon, { left: true }),
            react_1.default.createElement(TopbarSelectValueSpan, null, selected),
            react_1.default.createElement(isActive ? Icon_1.CaretUpIcon : Icon_1.CaretDownIcon, { size: 5, color: "color.text.lightest" }))))));
};
exports.default = TopbarSelect;
//# sourceMappingURL=TopbarSelect.js.map